import React from 'react';
import { Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import ReturnLists from './components/ReturnLists';

const Return = () => {
  const userdata = JSON.parse(localStorage.getItem('userData'));
  if (userdata === null) { // not admin
    return (<Redirect to="/dashboard" />);
  }

  return (
    <Container>
      <Row>
        <ReturnLists />
      </Row>
    </Container>
  );
};

export default Return;
